import React, { Component } from 'react';
import { Platform } from 'react-native';

import LottieView from 'lottie-react-native';
import propTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import Styles from './TrayLottie.Styles';

class TrayLottie extends Component {
  constructor(props) {
    super(props);
    this.lastLottiePosition = 0;
  }

  componentDidUpdate(prevProps) {

    const { isVisible } = this.props;

    if (prevProps.isVisible !== isVisible) {

      this.startAnimation(isVisible);
    }
  }

  startAnimation = isVisible => {
    const lottieStart = 19;
    if (isVisible) {
      this.lottie.play(10, lottieStart);
      this.lastLottiePosition = lottieStart;
    } else {
      // Max frame in android is 39, when passing a bigger number it causes a crash in the latest version of lottie.
      // We use 38 in stead of 39 (the max frame) because 38 produces the desired animation result while 39 causes the tray to over animate making it disappear.
      const lottieEnd = Platform.select({
        ios: 40,
        android: 38,
        web: 38
      });
      this.lottie.play(lottieStart, lottieEnd);
      this.lastLottiePosition = lottieEnd;
    }
  };

  render() {
    const { lottieStyle, theme } = this.props;
    const lottieJson =
      theme.name === 'dark'
        ? require('../trayLottie/dark_tray.json')
        : require('../trayLottie/tray.json');
    return (
      <LottieView
        style={[Styles.lottieViewStyles(theme), lottieStyle]}
        ref={lottie => {
          this.lottie = lottie;
        }}
        resizeMode="cover"
        // ip is the start position of lottie
        // IOS only: workaround to set the start position for new lottie to prev lottie position when theme is changed
        source={{
          ...lottieJson,
          ...(Platform.OS === 'ios' && { ip: this.lastLottiePosition }),
        }}
        pointerEvents={'box-none'}
        loop={false}
        speed={2}
        testID={FrameworkTestKeys.trayLottieView}
      />
    );
  }
}

TrayLottie.defaultProps = {
  theme: LightThemeColors,
};

TrayLottie.propTypes = {
  isVisible: propTypes.bool.isRequired,
  lottieStyle: propTypes.object,
  theme: propTypes.object,
};

export default withTheme(TrayLottie);
